import { literal, union } from 'io-ts/Decoder';

export const RangeType = union(
	literal('between'),
	literal('current'),
	literal('last'),
	literal('next'),
	literal('previous')
);
